import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Popper from '@material-ui/core/Popper';
import { Frame } from 'framer';

import { Tooltip, Close } from 'components'

class PopOut2 extends Component {
    constructor(props){
        super(props);
        this.Button = React.createRef();
        this.focusButton = this.focusButton.bind(this);
        this.state = {
            open: false,
            anchorEl: null,
            element: null
        }

        // Props
        this.tooltip = this.props.tooltip;
        this.trigger = this.props.trigger;
        this.element = this.props.element;
    }

    focusButton = () => {
        this.Button.current.focus();
    }

    clickHandler = (event, element) => {
        event.preventDefault()
        event.persist();
        // if(!this.state.open){
        this.setState({
            open: true,
            element: element,
            anchorEl: {getBoundingClientRect: () => (
                {
                    top: event.clientY,
                    left: event.clientX,
                    bottom: event.clientY,
                    right: event.clientX,
                    width: 1,
                    height: 1,
                }),
                clientWidth: 1,
                clientHeight: 1
            }
        })
        // } 
        console.log('PopOut2.js clickHandler', {state: this.state, event: event, element, element})
    }

    render(){
        const mainContent = <div onClick={this.trigger == 'leftClick' ? this.clickHandler : null} 
                                onContextMenu={this.trigger == 'rightClick' ? this.clickHandler : null}>
                            <Popper style={{zIndex: 101}} id='TagInputPopper' open={this.state.open} anchorEl={this.state.anchorEl} placement='bottom-start'>
                                <Frame size='100%' position="relative" background='transparent'
                                    positionTransition
                                    initial={{ opacity: 0, y: -10, scale: 0.5 }}
                                    animate={{ opacity: 1, y: 0, scale: 1 }}
                                    exit={{ opacity: 0, y: 10, scale: 0.5 }}>
                                    {this.state.element}
                                </Frame>
                            </Popper>
                            {this.state.open  ? <Close onClick={this.clickHandler} /> : null}
                        </div>
        if(this.tooltip){
            return (
                <Tooltip title={this.tooltip}>
                    {mainContent}
                </Tooltip>
            )
        } else {
            return (<div>{mainContent}</div>)
        }
    }
}

export default PopOut2;

PopOut2.propTypes = {
    element: PropTypes.element.isRequired,
    trigger: PropTypes.oneOf(['leftClick','rightClick']),
    tooltip: PropTypes.string,
}